import { useAngularContext } from 'AngularContext';
import { type OfflineModeManager } from 'OfflineMode';

export function useOfflineModeManager() {
    const $injector = useAngularContext();
    const offlineModeManager = $injector.get<OfflineModeManager>('offlineModeManager');
    return offlineModeManager;
}
